import * as D from './deps';

const LoginKeys = D.Constants.Login.LoginKeys;

// Shared
export function getLoginErrorKey(state) {
  return state.login.get(LoginKeys.LOGIN_ERROR_KEY);
}

export function isCaptchaRequired(state) {
  return state.login.get(LoginKeys.IS_CAPTCHA_REQUIRED);
}

// Forgot Password
export function getShowPasswordRecoveryEmailSent(state) {
  return state.login.get(LoginKeys.HAS_EMAILED_PASSWORD_RESET);
}

export function getSubmittedPasswordRecoveryUsername(state) {
  return state.login.get(LoginKeys.EMAIL_PASSWORD_USERNAME);
}

// Login
export function getPreviousUsername(state) {
  return state.login.get(LoginKeys.PREVIOUS_USERNAME);
}

export function getDefaultResetPasswordUsername(state) {
  return state.login.get(LoginKeys.DEFAULT_RESET_PASSWORD_USERNAME);
}

export function getLoginFailCount(state) {
  return state.login.get(LoginKeys.LOGIN_FAIL_COUNT);
}

// Reset Password
export function isResetTokenInvalid(state) {
  return state.login.get(LoginKeys.RESET_TOKEN_INVALID);
}

export function getResetPasswordToken(state) {
  return D.Utils.QueryParams.get(
    state,
    D.Constants.App.StartupQueryParameterKeys.RESET_PASSWORD_TOKEN,
  );
}

export function getEmailToReset(state) {
  return state.login.get(LoginKeys.USER_TO_RESET_PASSWORD);
}

export function getResetPasswordApiError(state) {
  return state.login.get(LoginKeys.RESET_PASSWORD_API_ERROR);
}

export function getRegistrationErrorCodeKey(state) {
  return state.register.get(LoginKeys.REGISTRATION_ERROR_CODE_KEY);
}
